/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ExamStatusRouteImport } from './routes/exam-status'
import { Route as ExamPortalRouteImport } from './routes/exam-portal'
import { Route as ExamAccessRouteImport } from './routes/exam-access'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as ExamPortalIndexRouteImport } from './routes/exam-portal/index'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedTeacherRouteImport } from './routes/_authed/teacher'
import { Route as AuthedScheduleRouteImport } from './routes/_authed/schedule'
import { Route as AuthedParentRouteImport } from './routes/_authed/parent'
import { Route as AuthedOwnerRouteImport } from './routes/_authed/owner'
import { Route as AuthedMyMockExamsRouteImport } from './routes/_authed/my-mock-exams'
import { Route as AuthedMaterialsRouteImport } from './routes/_authed/materials'
import { Route as AuthedLeadsRouteImport } from './routes/_authed/leads'
import { Route as AuthedHomeworkRouteImport } from './routes/_authed/homework'
import { Route as AuthedGradesRouteImport } from './routes/_authed/grades'
import { Route as AuthedForbiddenRouteImport } from './routes/_authed/forbidden'
import { Route as AuthedCalculatorRouteImport } from './routes/_authed/calculator'
import { Route as AuthedAssessmentsRouteImport } from './routes/_authed/assessments'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedTeacherIndexRouteImport } from './routes/_authed/teacher/index'
import { Route as AuthedParentIndexRouteImport } from './routes/_authed/parent/index'
import { Route as AuthedOwnerIndexRouteImport } from './routes/_authed/owner/index'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as ExamPortalRegistrationIdTakeRouteImport } from './routes/exam-portal/$registrationId/take'
import { Route as AuthedTeacherScheduleRouteImport } from './routes/_authed/teacher/schedule'
import { Route as AuthedTeacherPayrollRouteImport } from './routes/_authed/teacher/payroll'
import { Route as AuthedTeacherMockExamsRouteImport } from './routes/_authed/teacher/mock-exams'
import { Route as AuthedTeacherMaterialsRouteImport } from './routes/_authed/teacher/materials'
import { Route as AuthedTeacherLessonRouteImport } from './routes/_authed/teacher/lesson'
import { Route as AuthedTeacherHomeworkRouteImport } from './routes/_authed/teacher/homework'
import { Route as AuthedTeacherGroupsRouteImport } from './routes/_authed/teacher/groups'
import { Route as AuthedTeacherGradesRouteImport } from './routes/_authed/teacher/grades'
import { Route as AuthedTeacherAttendanceRouteImport } from './routes/_authed/teacher/attendance'
import { Route as AuthedTeacherAssessmentsRouteImport } from './routes/_authed/teacher/assessments'
import { Route as AuthedParentScheduleRouteImport } from './routes/_authed/parent/schedule'
import { Route as AuthedParentPerformanceRouteImport } from './routes/_authed/parent/performance'
import { Route as AuthedParentNotificationsRouteImport } from './routes/_authed/parent/notifications'
import { Route as AuthedParentHistoryRouteImport } from './routes/_authed/parent/history'
import { Route as AuthedParentBehaviorRouteImport } from './routes/_authed/parent/behavior'
import { Route as AuthedParentBalancesRouteImport } from './routes/_authed/parent/balances'
import { Route as AuthedParentAttendanceRouteImport } from './routes/_authed/parent/attendance'
import { Route as AuthedOwnerSiteRouteImport } from './routes/_authed/owner/site'
import { Route as AuthedOwnerPayrollRouteImport } from './routes/_authed/owner/payroll'
import { Route as AuthedOwnerPaymentAccountsRouteImport } from './routes/_authed/owner/payment-accounts'
import { Route as AuthedOwnerLogsRouteImport } from './routes/_authed/owner/logs'
import { Route as AuthedOwnerCrmReasonsRouteImport } from './routes/_authed/owner/crm-reasons'
import { Route as AuthedOwnerAdminsRouteImport } from './routes/_authed/owner/admins'
import { Route as AuthedLearningWorkIdRouteImport } from './routes/_authed/learning.$workId'
import { Route as AuthedAdminScheduleRouteImport } from './routes/_authed/admin/schedule'
import { Route as AuthedAdminRequestsRouteImport } from './routes/_authed/admin/requests'
import { Route as AuthedAdminPeopleRouteImport } from './routes/_authed/admin/people'
import { Route as AuthedAdminPayrollRouteImport } from './routes/_authed/admin/payroll'
import { Route as AuthedAdminMockExamsRouteImport } from './routes/_authed/admin/mock-exams'
import { Route as AuthedAdminMaterialsRouteImport } from './routes/_authed/admin/materials'
import { Route as AuthedAdminLessonsRouteImport } from './routes/_authed/admin/lessons'
import { Route as AuthedAdminLearningRouteImport } from './routes/_authed/admin/learning'
import { Route as AuthedAdminGroupsRouteImport } from './routes/_authed/admin/groups'
import { Route as AuthedAdminDesmosRouteImport } from './routes/_authed/admin/desmos'
import { Route as AuthedAdminAssessmentsRouteImport } from './routes/_authed/admin/assessments'
import { Route as AuthedAdminAnnouncementsRouteImport } from './routes/_authed/admin/announcements'
import { Route as AuthedAdminAdmissionsRouteImport } from './routes/_authed/admin/admissions'
import { Route as AuthedAdminAccountingRouteImport } from './routes/_authed/admin/accounting'
import { Route as AuthedOwnerSiteIndexRouteImport } from './routes/_authed/owner/site/index'
import { Route as AuthedAdminMockExamsIndexRouteImport } from './routes/_authed/admin/mock-exams/index'
import { Route as AuthedAdminAssessmentsIndexRouteImport } from './routes/_authed/admin/assessments/index'
import { Route as AuthedOwnerSiteTestimonialsRouteImport } from './routes/_authed/owner/site/testimonials'
import { Route as AuthedOwnerSiteSubjectsRouteImport } from './routes/_authed/owner/site/subjects'
import { Route as AuthedOwnerSiteResultsRouteImport } from './routes/_authed/owner/site/results'
import { Route as AuthedOwnerSiteDirectionsRouteImport } from './routes/_authed/owner/site/directions'
import { Route as AuthedOwnerSiteCoursesRouteImport } from './routes/_authed/owner/site/courses'
import { Route as AuthedOwnerSiteContentRouteImport } from './routes/_authed/owner/site/content'
import { Route as AuthedAdminAssessmentsNewRouteImport } from './routes/_authed/admin/assessments/new'
import { Route as AuthedAdminAssessmentsTemplateIdEditRouteImport } from './routes/_authed/admin/assessments/$templateId/edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ExamStatusRoute = ExamStatusRouteImport.update({
  id: '/exam-status',
  path: '/exam-status',
  getParentRoute: () => rootRouteImport,
} as any)
const ExamPortalRoute = ExamPortalRouteImport.update({
  id: '/exam-portal',
  path: '/exam-portal',
  getParentRoute: () => rootRouteImport,
} as any)
const ExamAccessRoute = ExamAccessRouteImport.update({
  id: '/exam-access',
  path: '/exam-access',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const ExamPortalIndexRoute = ExamPortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExamPortalRoute,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeacherRoute = AuthedTeacherRouteImport.update({
  id: '/teacher',
  path: '/teacher',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedScheduleRoute = AuthedScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedParentRoute = AuthedParentRouteImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOwnerRoute = AuthedOwnerRouteImport.update({
  id: '/owner',
  path: '/owner',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMyMockExamsRoute = AuthedMyMockExamsRouteImport.update({
  id: '/my-mock-exams',
  path: '/my-mock-exams',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMaterialsRoute = AuthedMaterialsRouteImport.update({
  id: '/materials',
  path: '/materials',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLeadsRoute = AuthedLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHomeworkRoute = AuthedHomeworkRouteImport.update({
  id: '/homework',
  path: '/homework',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGradesRoute = AuthedGradesRouteImport.update({
  id: '/grades',
  path: '/grades',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedForbiddenRoute = AuthedForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCalculatorRoute = AuthedCalculatorRouteImport.update({
  id: '/calculator',
  path: '/calculator',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAssessmentsRoute = AuthedAssessmentsRouteImport.update({
  id: '/assessments',
  path: '/assessments',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeacherIndexRoute = AuthedTeacherIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedParentIndexRoute = AuthedParentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedParentRoute,
} as any)
const AuthedOwnerIndexRoute = AuthedOwnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedOwnerRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const ExamPortalRegistrationIdTakeRoute =
  ExamPortalRegistrationIdTakeRouteImport.update({
    id: '/$registrationId/take',
    path: '/$registrationId/take',
    getParentRoute: () => ExamPortalRoute,
  } as any)
const AuthedTeacherScheduleRoute = AuthedTeacherScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherPayrollRoute = AuthedTeacherPayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherMockExamsRoute = AuthedTeacherMockExamsRouteImport.update({
  id: '/mock-exams',
  path: '/mock-exams',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherMaterialsRoute = AuthedTeacherMaterialsRouteImport.update({
  id: '/materials',
  path: '/materials',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherLessonRoute = AuthedTeacherLessonRouteImport.update({
  id: '/lesson',
  path: '/lesson',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherHomeworkRoute = AuthedTeacherHomeworkRouteImport.update({
  id: '/homework',
  path: '/homework',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherGroupsRoute = AuthedTeacherGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherGradesRoute = AuthedTeacherGradesRouteImport.update({
  id: '/grades',
  path: '/grades',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherAttendanceRoute = AuthedTeacherAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AuthedTeacherRoute,
} as any)
const AuthedTeacherAssessmentsRoute =
  AuthedTeacherAssessmentsRouteImport.update({
    id: '/assessments',
    path: '/assessments',
    getParentRoute: () => AuthedTeacherRoute,
  } as any)
const AuthedParentScheduleRoute = AuthedParentScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthedParentRoute,
} as any)
const AuthedParentPerformanceRoute = AuthedParentPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AuthedParentRoute,
} as any)
const AuthedParentNotificationsRoute =
  AuthedParentNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthedParentRoute,
  } as any)
const AuthedParentHistoryRoute = AuthedParentHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AuthedParentRoute,
} as any)
const AuthedParentBehaviorRoute = AuthedParentBehaviorRouteImport.update({
  id: '/behavior',
  path: '/behavior',
  getParentRoute: () => AuthedParentRoute,
} as any)
const AuthedParentBalancesRoute = AuthedParentBalancesRouteImport.update({
  id: '/balances',
  path: '/balances',
  getParentRoute: () => AuthedParentRoute,
} as any)
const AuthedParentAttendanceRoute = AuthedParentAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AuthedParentRoute,
} as any)
const AuthedOwnerSiteRoute = AuthedOwnerSiteRouteImport.update({
  id: '/site',
  path: '/site',
  getParentRoute: () => AuthedOwnerRoute,
} as any)
const AuthedOwnerPayrollRoute = AuthedOwnerPayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AuthedOwnerRoute,
} as any)
const AuthedOwnerPaymentAccountsRoute =
  AuthedOwnerPaymentAccountsRouteImport.update({
    id: '/payment-accounts',
    path: '/payment-accounts',
    getParentRoute: () => AuthedOwnerRoute,
  } as any)
const AuthedOwnerLogsRoute = AuthedOwnerLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AuthedOwnerRoute,
} as any)
const AuthedOwnerCrmReasonsRoute = AuthedOwnerCrmReasonsRouteImport.update({
  id: '/crm-reasons',
  path: '/crm-reasons',
  getParentRoute: () => AuthedOwnerRoute,
} as any)
const AuthedOwnerAdminsRoute = AuthedOwnerAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AuthedOwnerRoute,
} as any)
const AuthedLearningWorkIdRoute = AuthedLearningWorkIdRouteImport.update({
  id: '/learning/$workId',
  path: '/learning/$workId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminScheduleRoute = AuthedAdminScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminRequestsRoute = AuthedAdminRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminPeopleRoute = AuthedAdminPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminPayrollRoute = AuthedAdminPayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminMockExamsRoute = AuthedAdminMockExamsRouteImport.update({
  id: '/mock-exams',
  path: '/mock-exams',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminMaterialsRoute = AuthedAdminMaterialsRouteImport.update({
  id: '/materials',
  path: '/materials',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminLessonsRoute = AuthedAdminLessonsRouteImport.update({
  id: '/lessons',
  path: '/lessons',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminLearningRoute = AuthedAdminLearningRouteImport.update({
  id: '/learning',
  path: '/learning',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminGroupsRoute = AuthedAdminGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminDesmosRoute = AuthedAdminDesmosRouteImport.update({
  id: '/desmos',
  path: '/desmos',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAssessmentsRoute = AuthedAdminAssessmentsRouteImport.update({
  id: '/assessments',
  path: '/assessments',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAnnouncementsRoute =
  AuthedAdminAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdmissionsRoute = AuthedAdminAdmissionsRouteImport.update({
  id: '/admissions',
  path: '/admissions',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAccountingRoute = AuthedAdminAccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedOwnerSiteIndexRoute = AuthedOwnerSiteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedOwnerSiteRoute,
} as any)
const AuthedAdminMockExamsIndexRoute =
  AuthedAdminMockExamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAdminMockExamsRoute,
  } as any)
const AuthedAdminAssessmentsIndexRoute =
  AuthedAdminAssessmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAdminAssessmentsRoute,
  } as any)
const AuthedOwnerSiteTestimonialsRoute =
  AuthedOwnerSiteTestimonialsRouteImport.update({
    id: '/testimonials',
    path: '/testimonials',
    getParentRoute: () => AuthedOwnerSiteRoute,
  } as any)
const AuthedOwnerSiteSubjectsRoute = AuthedOwnerSiteSubjectsRouteImport.update({
  id: '/subjects',
  path: '/subjects',
  getParentRoute: () => AuthedOwnerSiteRoute,
} as any)
const AuthedOwnerSiteResultsRoute = AuthedOwnerSiteResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => AuthedOwnerSiteRoute,
} as any)
const AuthedOwnerSiteDirectionsRoute =
  AuthedOwnerSiteDirectionsRouteImport.update({
    id: '/directions',
    path: '/directions',
    getParentRoute: () => AuthedOwnerSiteRoute,
  } as any)
const AuthedOwnerSiteCoursesRoute = AuthedOwnerSiteCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => AuthedOwnerSiteRoute,
} as any)
const AuthedOwnerSiteContentRoute = AuthedOwnerSiteContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AuthedOwnerSiteRoute,
} as any)
const AuthedAdminAssessmentsNewRoute =
  AuthedAdminAssessmentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedAdminAssessmentsRoute,
  } as any)
const AuthedAdminAssessmentsTemplateIdEditRoute =
  AuthedAdminAssessmentsTemplateIdEditRouteImport.update({
    id: '/$templateId/edit',
    path: '/$templateId/edit',
    getParentRoute: () => AuthedAdminAssessmentsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/exam-access': typeof ExamAccessRoute
  '/exam-portal': typeof ExamPortalRouteWithChildren
  '/exam-status': typeof ExamStatusRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/assessments': typeof AuthedAssessmentsRoute
  '/calculator': typeof AuthedCalculatorRoute
  '/forbidden': typeof AuthedForbiddenRoute
  '/grades': typeof AuthedGradesRoute
  '/homework': typeof AuthedHomeworkRoute
  '/leads': typeof AuthedLeadsRoute
  '/materials': typeof AuthedMaterialsRoute
  '/my-mock-exams': typeof AuthedMyMockExamsRoute
  '/owner': typeof AuthedOwnerRouteWithChildren
  '/parent': typeof AuthedParentRouteWithChildren
  '/schedule': typeof AuthedScheduleRoute
  '/teacher': typeof AuthedTeacherRouteWithChildren
  '/exam-portal/': typeof ExamPortalIndexRoute
  '/admin/accounting': typeof AuthedAdminAccountingRoute
  '/admin/admissions': typeof AuthedAdminAdmissionsRoute
  '/admin/announcements': typeof AuthedAdminAnnouncementsRoute
  '/admin/assessments': typeof AuthedAdminAssessmentsRouteWithChildren
  '/admin/desmos': typeof AuthedAdminDesmosRoute
  '/admin/groups': typeof AuthedAdminGroupsRoute
  '/admin/learning': typeof AuthedAdminLearningRoute
  '/admin/lessons': typeof AuthedAdminLessonsRoute
  '/admin/materials': typeof AuthedAdminMaterialsRoute
  '/admin/mock-exams': typeof AuthedAdminMockExamsRouteWithChildren
  '/admin/payroll': typeof AuthedAdminPayrollRoute
  '/admin/people': typeof AuthedAdminPeopleRoute
  '/admin/requests': typeof AuthedAdminRequestsRoute
  '/admin/schedule': typeof AuthedAdminScheduleRoute
  '/learning/$workId': typeof AuthedLearningWorkIdRoute
  '/owner/admins': typeof AuthedOwnerAdminsRoute
  '/owner/crm-reasons': typeof AuthedOwnerCrmReasonsRoute
  '/owner/logs': typeof AuthedOwnerLogsRoute
  '/owner/payment-accounts': typeof AuthedOwnerPaymentAccountsRoute
  '/owner/payroll': typeof AuthedOwnerPayrollRoute
  '/owner/site': typeof AuthedOwnerSiteRouteWithChildren
  '/parent/attendance': typeof AuthedParentAttendanceRoute
  '/parent/balances': typeof AuthedParentBalancesRoute
  '/parent/behavior': typeof AuthedParentBehaviorRoute
  '/parent/history': typeof AuthedParentHistoryRoute
  '/parent/notifications': typeof AuthedParentNotificationsRoute
  '/parent/performance': typeof AuthedParentPerformanceRoute
  '/parent/schedule': typeof AuthedParentScheduleRoute
  '/teacher/assessments': typeof AuthedTeacherAssessmentsRoute
  '/teacher/attendance': typeof AuthedTeacherAttendanceRoute
  '/teacher/grades': typeof AuthedTeacherGradesRoute
  '/teacher/groups': typeof AuthedTeacherGroupsRoute
  '/teacher/homework': typeof AuthedTeacherHomeworkRoute
  '/teacher/lesson': typeof AuthedTeacherLessonRoute
  '/teacher/materials': typeof AuthedTeacherMaterialsRoute
  '/teacher/mock-exams': typeof AuthedTeacherMockExamsRoute
  '/teacher/payroll': typeof AuthedTeacherPayrollRoute
  '/teacher/schedule': typeof AuthedTeacherScheduleRoute
  '/exam-portal/$registrationId/take': typeof ExamPortalRegistrationIdTakeRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/owner/': typeof AuthedOwnerIndexRoute
  '/parent/': typeof AuthedParentIndexRoute
  '/teacher/': typeof AuthedTeacherIndexRoute
  '/admin/assessments/new': typeof AuthedAdminAssessmentsNewRoute
  '/owner/site/content': typeof AuthedOwnerSiteContentRoute
  '/owner/site/courses': typeof AuthedOwnerSiteCoursesRoute
  '/owner/site/directions': typeof AuthedOwnerSiteDirectionsRoute
  '/owner/site/results': typeof AuthedOwnerSiteResultsRoute
  '/owner/site/subjects': typeof AuthedOwnerSiteSubjectsRoute
  '/owner/site/testimonials': typeof AuthedOwnerSiteTestimonialsRoute
  '/admin/assessments/': typeof AuthedAdminAssessmentsIndexRoute
  '/admin/mock-exams/': typeof AuthedAdminMockExamsIndexRoute
  '/owner/site/': typeof AuthedOwnerSiteIndexRoute
  '/admin/assessments/$templateId/edit': typeof AuthedAdminAssessmentsTemplateIdEditRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/exam-access': typeof ExamAccessRoute
  '/exam-status': typeof ExamStatusRoute
  '/login': typeof LoginRoute
  '/assessments': typeof AuthedAssessmentsRoute
  '/calculator': typeof AuthedCalculatorRoute
  '/forbidden': typeof AuthedForbiddenRoute
  '/grades': typeof AuthedGradesRoute
  '/homework': typeof AuthedHomeworkRoute
  '/leads': typeof AuthedLeadsRoute
  '/materials': typeof AuthedMaterialsRoute
  '/my-mock-exams': typeof AuthedMyMockExamsRoute
  '/schedule': typeof AuthedScheduleRoute
  '/': typeof AuthedIndexRoute
  '/exam-portal': typeof ExamPortalIndexRoute
  '/admin/accounting': typeof AuthedAdminAccountingRoute
  '/admin/admissions': typeof AuthedAdminAdmissionsRoute
  '/admin/announcements': typeof AuthedAdminAnnouncementsRoute
  '/admin/desmos': typeof AuthedAdminDesmosRoute
  '/admin/groups': typeof AuthedAdminGroupsRoute
  '/admin/learning': typeof AuthedAdminLearningRoute
  '/admin/lessons': typeof AuthedAdminLessonsRoute
  '/admin/materials': typeof AuthedAdminMaterialsRoute
  '/admin/payroll': typeof AuthedAdminPayrollRoute
  '/admin/people': typeof AuthedAdminPeopleRoute
  '/admin/requests': typeof AuthedAdminRequestsRoute
  '/admin/schedule': typeof AuthedAdminScheduleRoute
  '/learning/$workId': typeof AuthedLearningWorkIdRoute
  '/owner/admins': typeof AuthedOwnerAdminsRoute
  '/owner/crm-reasons': typeof AuthedOwnerCrmReasonsRoute
  '/owner/logs': typeof AuthedOwnerLogsRoute
  '/owner/payment-accounts': typeof AuthedOwnerPaymentAccountsRoute
  '/owner/payroll': typeof AuthedOwnerPayrollRoute
  '/parent/attendance': typeof AuthedParentAttendanceRoute
  '/parent/balances': typeof AuthedParentBalancesRoute
  '/parent/behavior': typeof AuthedParentBehaviorRoute
  '/parent/history': typeof AuthedParentHistoryRoute
  '/parent/notifications': typeof AuthedParentNotificationsRoute
  '/parent/performance': typeof AuthedParentPerformanceRoute
  '/parent/schedule': typeof AuthedParentScheduleRoute
  '/teacher/assessments': typeof AuthedTeacherAssessmentsRoute
  '/teacher/attendance': typeof AuthedTeacherAttendanceRoute
  '/teacher/grades': typeof AuthedTeacherGradesRoute
  '/teacher/groups': typeof AuthedTeacherGroupsRoute
  '/teacher/homework': typeof AuthedTeacherHomeworkRoute
  '/teacher/lesson': typeof AuthedTeacherLessonRoute
  '/teacher/materials': typeof AuthedTeacherMaterialsRoute
  '/teacher/mock-exams': typeof AuthedTeacherMockExamsRoute
  '/teacher/payroll': typeof AuthedTeacherPayrollRoute
  '/teacher/schedule': typeof AuthedTeacherScheduleRoute
  '/exam-portal/$registrationId/take': typeof ExamPortalRegistrationIdTakeRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/owner': typeof AuthedOwnerIndexRoute
  '/parent': typeof AuthedParentIndexRoute
  '/teacher': typeof AuthedTeacherIndexRoute
  '/admin/assessments/new': typeof AuthedAdminAssessmentsNewRoute
  '/owner/site/content': typeof AuthedOwnerSiteContentRoute
  '/owner/site/courses': typeof AuthedOwnerSiteCoursesRoute
  '/owner/site/directions': typeof AuthedOwnerSiteDirectionsRoute
  '/owner/site/results': typeof AuthedOwnerSiteResultsRoute
  '/owner/site/subjects': typeof AuthedOwnerSiteSubjectsRoute
  '/owner/site/testimonials': typeof AuthedOwnerSiteTestimonialsRoute
  '/admin/assessments': typeof AuthedAdminAssessmentsIndexRoute
  '/admin/mock-exams': typeof AuthedAdminMockExamsIndexRoute
  '/owner/site': typeof AuthedOwnerSiteIndexRoute
  '/admin/assessments/$templateId/edit': typeof AuthedAdminAssessmentsTemplateIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/exam-access': typeof ExamAccessRoute
  '/exam-portal': typeof ExamPortalRouteWithChildren
  '/exam-status': typeof ExamStatusRoute
  '/login': typeof LoginRoute
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/assessments': typeof AuthedAssessmentsRoute
  '/_authed/calculator': typeof AuthedCalculatorRoute
  '/_authed/forbidden': typeof AuthedForbiddenRoute
  '/_authed/grades': typeof AuthedGradesRoute
  '/_authed/homework': typeof AuthedHomeworkRoute
  '/_authed/leads': typeof AuthedLeadsRoute
  '/_authed/materials': typeof AuthedMaterialsRoute
  '/_authed/my-mock-exams': typeof AuthedMyMockExamsRoute
  '/_authed/owner': typeof AuthedOwnerRouteWithChildren
  '/_authed/parent': typeof AuthedParentRouteWithChildren
  '/_authed/schedule': typeof AuthedScheduleRoute
  '/_authed/teacher': typeof AuthedTeacherRouteWithChildren
  '/_authed/': typeof AuthedIndexRoute
  '/exam-portal/': typeof ExamPortalIndexRoute
  '/_authed/admin/accounting': typeof AuthedAdminAccountingRoute
  '/_authed/admin/admissions': typeof AuthedAdminAdmissionsRoute
  '/_authed/admin/announcements': typeof AuthedAdminAnnouncementsRoute
  '/_authed/admin/assessments': typeof AuthedAdminAssessmentsRouteWithChildren
  '/_authed/admin/desmos': typeof AuthedAdminDesmosRoute
  '/_authed/admin/groups': typeof AuthedAdminGroupsRoute
  '/_authed/admin/learning': typeof AuthedAdminLearningRoute
  '/_authed/admin/lessons': typeof AuthedAdminLessonsRoute
  '/_authed/admin/materials': typeof AuthedAdminMaterialsRoute
  '/_authed/admin/mock-exams': typeof AuthedAdminMockExamsRouteWithChildren
  '/_authed/admin/payroll': typeof AuthedAdminPayrollRoute
  '/_authed/admin/people': typeof AuthedAdminPeopleRoute
  '/_authed/admin/requests': typeof AuthedAdminRequestsRoute
  '/_authed/admin/schedule': typeof AuthedAdminScheduleRoute
  '/_authed/learning/$workId': typeof AuthedLearningWorkIdRoute
  '/_authed/owner/admins': typeof AuthedOwnerAdminsRoute
  '/_authed/owner/crm-reasons': typeof AuthedOwnerCrmReasonsRoute
  '/_authed/owner/logs': typeof AuthedOwnerLogsRoute
  '/_authed/owner/payment-accounts': typeof AuthedOwnerPaymentAccountsRoute
  '/_authed/owner/payroll': typeof AuthedOwnerPayrollRoute
  '/_authed/owner/site': typeof AuthedOwnerSiteRouteWithChildren
  '/_authed/parent/attendance': typeof AuthedParentAttendanceRoute
  '/_authed/parent/balances': typeof AuthedParentBalancesRoute
  '/_authed/parent/behavior': typeof AuthedParentBehaviorRoute
  '/_authed/parent/history': typeof AuthedParentHistoryRoute
  '/_authed/parent/notifications': typeof AuthedParentNotificationsRoute
  '/_authed/parent/performance': typeof AuthedParentPerformanceRoute
  '/_authed/parent/schedule': typeof AuthedParentScheduleRoute
  '/_authed/teacher/assessments': typeof AuthedTeacherAssessmentsRoute
  '/_authed/teacher/attendance': typeof AuthedTeacherAttendanceRoute
  '/_authed/teacher/grades': typeof AuthedTeacherGradesRoute
  '/_authed/teacher/groups': typeof AuthedTeacherGroupsRoute
  '/_authed/teacher/homework': typeof AuthedTeacherHomeworkRoute
  '/_authed/teacher/lesson': typeof AuthedTeacherLessonRoute
  '/_authed/teacher/materials': typeof AuthedTeacherMaterialsRoute
  '/_authed/teacher/mock-exams': typeof AuthedTeacherMockExamsRoute
  '/_authed/teacher/payroll': typeof AuthedTeacherPayrollRoute
  '/_authed/teacher/schedule': typeof AuthedTeacherScheduleRoute
  '/exam-portal/$registrationId/take': typeof ExamPortalRegistrationIdTakeRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/owner/': typeof AuthedOwnerIndexRoute
  '/_authed/parent/': typeof AuthedParentIndexRoute
  '/_authed/teacher/': typeof AuthedTeacherIndexRoute
  '/_authed/admin/assessments/new': typeof AuthedAdminAssessmentsNewRoute
  '/_authed/owner/site/content': typeof AuthedOwnerSiteContentRoute
  '/_authed/owner/site/courses': typeof AuthedOwnerSiteCoursesRoute
  '/_authed/owner/site/directions': typeof AuthedOwnerSiteDirectionsRoute
  '/_authed/owner/site/results': typeof AuthedOwnerSiteResultsRoute
  '/_authed/owner/site/subjects': typeof AuthedOwnerSiteSubjectsRoute
  '/_authed/owner/site/testimonials': typeof AuthedOwnerSiteTestimonialsRoute
  '/_authed/admin/assessments/': typeof AuthedAdminAssessmentsIndexRoute
  '/_authed/admin/mock-exams/': typeof AuthedAdminMockExamsIndexRoute
  '/_authed/owner/site/': typeof AuthedOwnerSiteIndexRoute
  '/_authed/admin/assessments/$templateId/edit': typeof AuthedAdminAssessmentsTemplateIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/exam-access'
    | '/exam-portal'
    | '/exam-status'
    | '/login'
    | '/admin'
    | '/assessments'
    | '/calculator'
    | '/forbidden'
    | '/grades'
    | '/homework'
    | '/leads'
    | '/materials'
    | '/my-mock-exams'
    | '/owner'
    | '/parent'
    | '/schedule'
    | '/teacher'
    | '/exam-portal/'
    | '/admin/accounting'
    | '/admin/admissions'
    | '/admin/announcements'
    | '/admin/assessments'
    | '/admin/desmos'
    | '/admin/groups'
    | '/admin/learning'
    | '/admin/lessons'
    | '/admin/materials'
    | '/admin/mock-exams'
    | '/admin/payroll'
    | '/admin/people'
    | '/admin/requests'
    | '/admin/schedule'
    | '/learning/$workId'
    | '/owner/admins'
    | '/owner/crm-reasons'
    | '/owner/logs'
    | '/owner/payment-accounts'
    | '/owner/payroll'
    | '/owner/site'
    | '/parent/attendance'
    | '/parent/balances'
    | '/parent/behavior'
    | '/parent/history'
    | '/parent/notifications'
    | '/parent/performance'
    | '/parent/schedule'
    | '/teacher/assessments'
    | '/teacher/attendance'
    | '/teacher/grades'
    | '/teacher/groups'
    | '/teacher/homework'
    | '/teacher/lesson'
    | '/teacher/materials'
    | '/teacher/mock-exams'
    | '/teacher/payroll'
    | '/teacher/schedule'
    | '/exam-portal/$registrationId/take'
    | '/admin/'
    | '/owner/'
    | '/parent/'
    | '/teacher/'
    | '/admin/assessments/new'
    | '/owner/site/content'
    | '/owner/site/courses'
    | '/owner/site/directions'
    | '/owner/site/results'
    | '/owner/site/subjects'
    | '/owner/site/testimonials'
    | '/admin/assessments/'
    | '/admin/mock-exams/'
    | '/owner/site/'
    | '/admin/assessments/$templateId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/exam-access'
    | '/exam-status'
    | '/login'
    | '/assessments'
    | '/calculator'
    | '/forbidden'
    | '/grades'
    | '/homework'
    | '/leads'
    | '/materials'
    | '/my-mock-exams'
    | '/schedule'
    | '/'
    | '/exam-portal'
    | '/admin/accounting'
    | '/admin/admissions'
    | '/admin/announcements'
    | '/admin/desmos'
    | '/admin/groups'
    | '/admin/learning'
    | '/admin/lessons'
    | '/admin/materials'
    | '/admin/payroll'
    | '/admin/people'
    | '/admin/requests'
    | '/admin/schedule'
    | '/learning/$workId'
    | '/owner/admins'
    | '/owner/crm-reasons'
    | '/owner/logs'
    | '/owner/payment-accounts'
    | '/owner/payroll'
    | '/parent/attendance'
    | '/parent/balances'
    | '/parent/behavior'
    | '/parent/history'
    | '/parent/notifications'
    | '/parent/performance'
    | '/parent/schedule'
    | '/teacher/assessments'
    | '/teacher/attendance'
    | '/teacher/grades'
    | '/teacher/groups'
    | '/teacher/homework'
    | '/teacher/lesson'
    | '/teacher/materials'
    | '/teacher/mock-exams'
    | '/teacher/payroll'
    | '/teacher/schedule'
    | '/exam-portal/$registrationId/take'
    | '/admin'
    | '/owner'
    | '/parent'
    | '/teacher'
    | '/admin/assessments/new'
    | '/owner/site/content'
    | '/owner/site/courses'
    | '/owner/site/directions'
    | '/owner/site/results'
    | '/owner/site/subjects'
    | '/owner/site/testimonials'
    | '/admin/assessments'
    | '/admin/mock-exams'
    | '/owner/site'
    | '/admin/assessments/$templateId/edit'
  id:
    | '__root__'
    | '/_authed'
    | '/change-password'
    | '/exam-access'
    | '/exam-portal'
    | '/exam-status'
    | '/login'
    | '/_authed/admin'
    | '/_authed/assessments'
    | '/_authed/calculator'
    | '/_authed/forbidden'
    | '/_authed/grades'
    | '/_authed/homework'
    | '/_authed/leads'
    | '/_authed/materials'
    | '/_authed/my-mock-exams'
    | '/_authed/owner'
    | '/_authed/parent'
    | '/_authed/schedule'
    | '/_authed/teacher'
    | '/_authed/'
    | '/exam-portal/'
    | '/_authed/admin/accounting'
    | '/_authed/admin/admissions'
    | '/_authed/admin/announcements'
    | '/_authed/admin/assessments'
    | '/_authed/admin/desmos'
    | '/_authed/admin/groups'
    | '/_authed/admin/learning'
    | '/_authed/admin/lessons'
    | '/_authed/admin/materials'
    | '/_authed/admin/mock-exams'
    | '/_authed/admin/payroll'
    | '/_authed/admin/people'
    | '/_authed/admin/requests'
    | '/_authed/admin/schedule'
    | '/_authed/learning/$workId'
    | '/_authed/owner/admins'
    | '/_authed/owner/crm-reasons'
    | '/_authed/owner/logs'
    | '/_authed/owner/payment-accounts'
    | '/_authed/owner/payroll'
    | '/_authed/owner/site'
    | '/_authed/parent/attendance'
    | '/_authed/parent/balances'
    | '/_authed/parent/behavior'
    | '/_authed/parent/history'
    | '/_authed/parent/notifications'
    | '/_authed/parent/performance'
    | '/_authed/parent/schedule'
    | '/_authed/teacher/assessments'
    | '/_authed/teacher/attendance'
    | '/_authed/teacher/grades'
    | '/_authed/teacher/groups'
    | '/_authed/teacher/homework'
    | '/_authed/teacher/lesson'
    | '/_authed/teacher/materials'
    | '/_authed/teacher/mock-exams'
    | '/_authed/teacher/payroll'
    | '/_authed/teacher/schedule'
    | '/exam-portal/$registrationId/take'
    | '/_authed/admin/'
    | '/_authed/owner/'
    | '/_authed/parent/'
    | '/_authed/teacher/'
    | '/_authed/admin/assessments/new'
    | '/_authed/owner/site/content'
    | '/_authed/owner/site/courses'
    | '/_authed/owner/site/directions'
    | '/_authed/owner/site/results'
    | '/_authed/owner/site/subjects'
    | '/_authed/owner/site/testimonials'
    | '/_authed/admin/assessments/'
    | '/_authed/admin/mock-exams/'
    | '/_authed/owner/site/'
    | '/_authed/admin/assessments/$templateId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  ExamAccessRoute: typeof ExamAccessRoute
  ExamPortalRoute: typeof ExamPortalRouteWithChildren
  ExamStatusRoute: typeof ExamStatusRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exam-status': {
      id: '/exam-status'
      path: '/exam-status'
      fullPath: '/exam-status'
      preLoaderRoute: typeof ExamStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exam-portal': {
      id: '/exam-portal'
      path: '/exam-portal'
      fullPath: '/exam-portal'
      preLoaderRoute: typeof ExamPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exam-access': {
      id: '/exam-access'
      path: '/exam-access'
      fullPath: '/exam-access'
      preLoaderRoute: typeof ExamAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exam-portal/': {
      id: '/exam-portal/'
      path: '/'
      fullPath: '/exam-portal/'
      preLoaderRoute: typeof ExamPortalIndexRouteImport
      parentRoute: typeof ExamPortalRoute
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teacher': {
      id: '/_authed/teacher'
      path: '/teacher'
      fullPath: '/teacher'
      preLoaderRoute: typeof AuthedTeacherRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/schedule': {
      id: '/_authed/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthedScheduleRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/parent': {
      id: '/_authed/parent'
      path: '/parent'
      fullPath: '/parent'
      preLoaderRoute: typeof AuthedParentRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/owner': {
      id: '/_authed/owner'
      path: '/owner'
      fullPath: '/owner'
      preLoaderRoute: typeof AuthedOwnerRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/my-mock-exams': {
      id: '/_authed/my-mock-exams'
      path: '/my-mock-exams'
      fullPath: '/my-mock-exams'
      preLoaderRoute: typeof AuthedMyMockExamsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/materials': {
      id: '/_authed/materials'
      path: '/materials'
      fullPath: '/materials'
      preLoaderRoute: typeof AuthedMaterialsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/leads': {
      id: '/_authed/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AuthedLeadsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/homework': {
      id: '/_authed/homework'
      path: '/homework'
      fullPath: '/homework'
      preLoaderRoute: typeof AuthedHomeworkRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/grades': {
      id: '/_authed/grades'
      path: '/grades'
      fullPath: '/grades'
      preLoaderRoute: typeof AuthedGradesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/forbidden': {
      id: '/_authed/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof AuthedForbiddenRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/calculator': {
      id: '/_authed/calculator'
      path: '/calculator'
      fullPath: '/calculator'
      preLoaderRoute: typeof AuthedCalculatorRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/assessments': {
      id: '/_authed/assessments'
      path: '/assessments'
      fullPath: '/assessments'
      preLoaderRoute: typeof AuthedAssessmentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teacher/': {
      id: '/_authed/teacher/'
      path: '/'
      fullPath: '/teacher/'
      preLoaderRoute: typeof AuthedTeacherIndexRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/parent/': {
      id: '/_authed/parent/'
      path: '/'
      fullPath: '/parent/'
      preLoaderRoute: typeof AuthedParentIndexRouteImport
      parentRoute: typeof AuthedParentRoute
    }
    '/_authed/owner/': {
      id: '/_authed/owner/'
      path: '/'
      fullPath: '/owner/'
      preLoaderRoute: typeof AuthedOwnerIndexRouteImport
      parentRoute: typeof AuthedOwnerRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/exam-portal/$registrationId/take': {
      id: '/exam-portal/$registrationId/take'
      path: '/$registrationId/take'
      fullPath: '/exam-portal/$registrationId/take'
      preLoaderRoute: typeof ExamPortalRegistrationIdTakeRouteImport
      parentRoute: typeof ExamPortalRoute
    }
    '/_authed/teacher/schedule': {
      id: '/_authed/teacher/schedule'
      path: '/schedule'
      fullPath: '/teacher/schedule'
      preLoaderRoute: typeof AuthedTeacherScheduleRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/payroll': {
      id: '/_authed/teacher/payroll'
      path: '/payroll'
      fullPath: '/teacher/payroll'
      preLoaderRoute: typeof AuthedTeacherPayrollRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/mock-exams': {
      id: '/_authed/teacher/mock-exams'
      path: '/mock-exams'
      fullPath: '/teacher/mock-exams'
      preLoaderRoute: typeof AuthedTeacherMockExamsRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/materials': {
      id: '/_authed/teacher/materials'
      path: '/materials'
      fullPath: '/teacher/materials'
      preLoaderRoute: typeof AuthedTeacherMaterialsRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/lesson': {
      id: '/_authed/teacher/lesson'
      path: '/lesson'
      fullPath: '/teacher/lesson'
      preLoaderRoute: typeof AuthedTeacherLessonRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/homework': {
      id: '/_authed/teacher/homework'
      path: '/homework'
      fullPath: '/teacher/homework'
      preLoaderRoute: typeof AuthedTeacherHomeworkRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/groups': {
      id: '/_authed/teacher/groups'
      path: '/groups'
      fullPath: '/teacher/groups'
      preLoaderRoute: typeof AuthedTeacherGroupsRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/grades': {
      id: '/_authed/teacher/grades'
      path: '/grades'
      fullPath: '/teacher/grades'
      preLoaderRoute: typeof AuthedTeacherGradesRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/attendance': {
      id: '/_authed/teacher/attendance'
      path: '/attendance'
      fullPath: '/teacher/attendance'
      preLoaderRoute: typeof AuthedTeacherAttendanceRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/teacher/assessments': {
      id: '/_authed/teacher/assessments'
      path: '/assessments'
      fullPath: '/teacher/assessments'
      preLoaderRoute: typeof AuthedTeacherAssessmentsRouteImport
      parentRoute: typeof AuthedTeacherRoute
    }
    '/_authed/parent/schedule': {
      id: '/_authed/parent/schedule'
      path: '/schedule'
      fullPath: '/parent/schedule'
      preLoaderRoute: typeof AuthedParentScheduleRouteImport
      parentRoute: typeof AuthedParentRoute
    }
    '/_authed/parent/performance': {
      id: '/_authed/parent/performance'
      path: '/performance'
      fullPath: '/parent/performance'
      preLoaderRoute: typeof AuthedParentPerformanceRouteImport
      parentRoute: typeof AuthedParentRoute
    }
    '/_authed/parent/notifications': {
      id: '/_authed/parent/notifications'
      path: '/notifications'
      fullPath: '/parent/notifications'
      preLoaderRoute: typeof AuthedParentNotificationsRouteImport
      parentRoute: typeof AuthedParentRoute
    }
    '/_authed/parent/history': {
      id: '/_authed/parent/history'
      path: '/history'
      fullPath: '/parent/history'
      preLoaderRoute: typeof AuthedParentHistoryRouteImport
      parentRoute: typeof AuthedParentRoute
    }
    '/_authed/parent/behavior': {
      id: '/_authed/parent/behavior'
      path: '/behavior'
      fullPath: '/parent/behavior'
      preLoaderRoute: typeof AuthedParentBehaviorRouteImport
      parentRoute: typeof AuthedParentRoute
    }
    '/_authed/parent/balances': {
      id: '/_authed/parent/balances'
      path: '/balances'
      fullPath: '/parent/balances'
      preLoaderRoute: typeof AuthedParentBalancesRouteImport
      parentRoute: typeof AuthedParentRoute
    }
    '/_authed/parent/attendance': {
      id: '/_authed/parent/attendance'
      path: '/attendance'
      fullPath: '/parent/attendance'
      preLoaderRoute: typeof AuthedParentAttendanceRouteImport
      parentRoute: typeof AuthedParentRoute
    }
    '/_authed/owner/site': {
      id: '/_authed/owner/site'
      path: '/site'
      fullPath: '/owner/site'
      preLoaderRoute: typeof AuthedOwnerSiteRouteImport
      parentRoute: typeof AuthedOwnerRoute
    }
    '/_authed/owner/payroll': {
      id: '/_authed/owner/payroll'
      path: '/payroll'
      fullPath: '/owner/payroll'
      preLoaderRoute: typeof AuthedOwnerPayrollRouteImport
      parentRoute: typeof AuthedOwnerRoute
    }
    '/_authed/owner/payment-accounts': {
      id: '/_authed/owner/payment-accounts'
      path: '/payment-accounts'
      fullPath: '/owner/payment-accounts'
      preLoaderRoute: typeof AuthedOwnerPaymentAccountsRouteImport
      parentRoute: typeof AuthedOwnerRoute
    }
    '/_authed/owner/logs': {
      id: '/_authed/owner/logs'
      path: '/logs'
      fullPath: '/owner/logs'
      preLoaderRoute: typeof AuthedOwnerLogsRouteImport
      parentRoute: typeof AuthedOwnerRoute
    }
    '/_authed/owner/crm-reasons': {
      id: '/_authed/owner/crm-reasons'
      path: '/crm-reasons'
      fullPath: '/owner/crm-reasons'
      preLoaderRoute: typeof AuthedOwnerCrmReasonsRouteImport
      parentRoute: typeof AuthedOwnerRoute
    }
    '/_authed/owner/admins': {
      id: '/_authed/owner/admins'
      path: '/admins'
      fullPath: '/owner/admins'
      preLoaderRoute: typeof AuthedOwnerAdminsRouteImport
      parentRoute: typeof AuthedOwnerRoute
    }
    '/_authed/learning/$workId': {
      id: '/_authed/learning/$workId'
      path: '/learning/$workId'
      fullPath: '/learning/$workId'
      preLoaderRoute: typeof AuthedLearningWorkIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/schedule': {
      id: '/_authed/admin/schedule'
      path: '/schedule'
      fullPath: '/admin/schedule'
      preLoaderRoute: typeof AuthedAdminScheduleRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/requests': {
      id: '/_authed/admin/requests'
      path: '/requests'
      fullPath: '/admin/requests'
      preLoaderRoute: typeof AuthedAdminRequestsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/people': {
      id: '/_authed/admin/people'
      path: '/people'
      fullPath: '/admin/people'
      preLoaderRoute: typeof AuthedAdminPeopleRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/payroll': {
      id: '/_authed/admin/payroll'
      path: '/payroll'
      fullPath: '/admin/payroll'
      preLoaderRoute: typeof AuthedAdminPayrollRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/mock-exams': {
      id: '/_authed/admin/mock-exams'
      path: '/mock-exams'
      fullPath: '/admin/mock-exams'
      preLoaderRoute: typeof AuthedAdminMockExamsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/materials': {
      id: '/_authed/admin/materials'
      path: '/materials'
      fullPath: '/admin/materials'
      preLoaderRoute: typeof AuthedAdminMaterialsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/lessons': {
      id: '/_authed/admin/lessons'
      path: '/lessons'
      fullPath: '/admin/lessons'
      preLoaderRoute: typeof AuthedAdminLessonsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/learning': {
      id: '/_authed/admin/learning'
      path: '/learning'
      fullPath: '/admin/learning'
      preLoaderRoute: typeof AuthedAdminLearningRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/groups': {
      id: '/_authed/admin/groups'
      path: '/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof AuthedAdminGroupsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/desmos': {
      id: '/_authed/admin/desmos'
      path: '/desmos'
      fullPath: '/admin/desmos'
      preLoaderRoute: typeof AuthedAdminDesmosRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/assessments': {
      id: '/_authed/admin/assessments'
      path: '/assessments'
      fullPath: '/admin/assessments'
      preLoaderRoute: typeof AuthedAdminAssessmentsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/announcements': {
      id: '/_authed/admin/announcements'
      path: '/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AuthedAdminAnnouncementsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/admissions': {
      id: '/_authed/admin/admissions'
      path: '/admissions'
      fullPath: '/admin/admissions'
      preLoaderRoute: typeof AuthedAdminAdmissionsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/accounting': {
      id: '/_authed/admin/accounting'
      path: '/accounting'
      fullPath: '/admin/accounting'
      preLoaderRoute: typeof AuthedAdminAccountingRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/owner/site/': {
      id: '/_authed/owner/site/'
      path: '/'
      fullPath: '/owner/site/'
      preLoaderRoute: typeof AuthedOwnerSiteIndexRouteImport
      parentRoute: typeof AuthedOwnerSiteRoute
    }
    '/_authed/admin/mock-exams/': {
      id: '/_authed/admin/mock-exams/'
      path: '/'
      fullPath: '/admin/mock-exams/'
      preLoaderRoute: typeof AuthedAdminMockExamsIndexRouteImport
      parentRoute: typeof AuthedAdminMockExamsRoute
    }
    '/_authed/admin/assessments/': {
      id: '/_authed/admin/assessments/'
      path: '/'
      fullPath: '/admin/assessments/'
      preLoaderRoute: typeof AuthedAdminAssessmentsIndexRouteImport
      parentRoute: typeof AuthedAdminAssessmentsRoute
    }
    '/_authed/owner/site/testimonials': {
      id: '/_authed/owner/site/testimonials'
      path: '/testimonials'
      fullPath: '/owner/site/testimonials'
      preLoaderRoute: typeof AuthedOwnerSiteTestimonialsRouteImport
      parentRoute: typeof AuthedOwnerSiteRoute
    }
    '/_authed/owner/site/subjects': {
      id: '/_authed/owner/site/subjects'
      path: '/subjects'
      fullPath: '/owner/site/subjects'
      preLoaderRoute: typeof AuthedOwnerSiteSubjectsRouteImport
      parentRoute: typeof AuthedOwnerSiteRoute
    }
    '/_authed/owner/site/results': {
      id: '/_authed/owner/site/results'
      path: '/results'
      fullPath: '/owner/site/results'
      preLoaderRoute: typeof AuthedOwnerSiteResultsRouteImport
      parentRoute: typeof AuthedOwnerSiteRoute
    }
    '/_authed/owner/site/directions': {
      id: '/_authed/owner/site/directions'
      path: '/directions'
      fullPath: '/owner/site/directions'
      preLoaderRoute: typeof AuthedOwnerSiteDirectionsRouteImport
      parentRoute: typeof AuthedOwnerSiteRoute
    }
    '/_authed/owner/site/courses': {
      id: '/_authed/owner/site/courses'
      path: '/courses'
      fullPath: '/owner/site/courses'
      preLoaderRoute: typeof AuthedOwnerSiteCoursesRouteImport
      parentRoute: typeof AuthedOwnerSiteRoute
    }
    '/_authed/owner/site/content': {
      id: '/_authed/owner/site/content'
      path: '/content'
      fullPath: '/owner/site/content'
      preLoaderRoute: typeof AuthedOwnerSiteContentRouteImport
      parentRoute: typeof AuthedOwnerSiteRoute
    }
    '/_authed/admin/assessments/new': {
      id: '/_authed/admin/assessments/new'
      path: '/new'
      fullPath: '/admin/assessments/new'
      preLoaderRoute: typeof AuthedAdminAssessmentsNewRouteImport
      parentRoute: typeof AuthedAdminAssessmentsRoute
    }
    '/_authed/admin/assessments/$templateId/edit': {
      id: '/_authed/admin/assessments/$templateId/edit'
      path: '/$templateId/edit'
      fullPath: '/admin/assessments/$templateId/edit'
      preLoaderRoute: typeof AuthedAdminAssessmentsTemplateIdEditRouteImport
      parentRoute: typeof AuthedAdminAssessmentsRoute
    }
  }
}

interface AuthedAdminAssessmentsRouteChildren {
  AuthedAdminAssessmentsNewRoute: typeof AuthedAdminAssessmentsNewRoute
  AuthedAdminAssessmentsIndexRoute: typeof AuthedAdminAssessmentsIndexRoute
  AuthedAdminAssessmentsTemplateIdEditRoute: typeof AuthedAdminAssessmentsTemplateIdEditRoute
}

const AuthedAdminAssessmentsRouteChildren: AuthedAdminAssessmentsRouteChildren =
  {
    AuthedAdminAssessmentsNewRoute: AuthedAdminAssessmentsNewRoute,
    AuthedAdminAssessmentsIndexRoute: AuthedAdminAssessmentsIndexRoute,
    AuthedAdminAssessmentsTemplateIdEditRoute:
      AuthedAdminAssessmentsTemplateIdEditRoute,
  }

const AuthedAdminAssessmentsRouteWithChildren =
  AuthedAdminAssessmentsRoute._addFileChildren(
    AuthedAdminAssessmentsRouteChildren,
  )

interface AuthedAdminMockExamsRouteChildren {
  AuthedAdminMockExamsIndexRoute: typeof AuthedAdminMockExamsIndexRoute
}

const AuthedAdminMockExamsRouteChildren: AuthedAdminMockExamsRouteChildren = {
  AuthedAdminMockExamsIndexRoute: AuthedAdminMockExamsIndexRoute,
}

const AuthedAdminMockExamsRouteWithChildren =
  AuthedAdminMockExamsRoute._addFileChildren(AuthedAdminMockExamsRouteChildren)

interface AuthedAdminRouteChildren {
  AuthedAdminAccountingRoute: typeof AuthedAdminAccountingRoute
  AuthedAdminAdmissionsRoute: typeof AuthedAdminAdmissionsRoute
  AuthedAdminAnnouncementsRoute: typeof AuthedAdminAnnouncementsRoute
  AuthedAdminAssessmentsRoute: typeof AuthedAdminAssessmentsRouteWithChildren
  AuthedAdminDesmosRoute: typeof AuthedAdminDesmosRoute
  AuthedAdminGroupsRoute: typeof AuthedAdminGroupsRoute
  AuthedAdminLearningRoute: typeof AuthedAdminLearningRoute
  AuthedAdminLessonsRoute: typeof AuthedAdminLessonsRoute
  AuthedAdminMaterialsRoute: typeof AuthedAdminMaterialsRoute
  AuthedAdminMockExamsRoute: typeof AuthedAdminMockExamsRouteWithChildren
  AuthedAdminPayrollRoute: typeof AuthedAdminPayrollRoute
  AuthedAdminPeopleRoute: typeof AuthedAdminPeopleRoute
  AuthedAdminRequestsRoute: typeof AuthedAdminRequestsRoute
  AuthedAdminScheduleRoute: typeof AuthedAdminScheduleRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminAccountingRoute: AuthedAdminAccountingRoute,
  AuthedAdminAdmissionsRoute: AuthedAdminAdmissionsRoute,
  AuthedAdminAnnouncementsRoute: AuthedAdminAnnouncementsRoute,
  AuthedAdminAssessmentsRoute: AuthedAdminAssessmentsRouteWithChildren,
  AuthedAdminDesmosRoute: AuthedAdminDesmosRoute,
  AuthedAdminGroupsRoute: AuthedAdminGroupsRoute,
  AuthedAdminLearningRoute: AuthedAdminLearningRoute,
  AuthedAdminLessonsRoute: AuthedAdminLessonsRoute,
  AuthedAdminMaterialsRoute: AuthedAdminMaterialsRoute,
  AuthedAdminMockExamsRoute: AuthedAdminMockExamsRouteWithChildren,
  AuthedAdminPayrollRoute: AuthedAdminPayrollRoute,
  AuthedAdminPeopleRoute: AuthedAdminPeopleRoute,
  AuthedAdminRequestsRoute: AuthedAdminRequestsRoute,
  AuthedAdminScheduleRoute: AuthedAdminScheduleRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedOwnerSiteRouteChildren {
  AuthedOwnerSiteContentRoute: typeof AuthedOwnerSiteContentRoute
  AuthedOwnerSiteCoursesRoute: typeof AuthedOwnerSiteCoursesRoute
  AuthedOwnerSiteDirectionsRoute: typeof AuthedOwnerSiteDirectionsRoute
  AuthedOwnerSiteResultsRoute: typeof AuthedOwnerSiteResultsRoute
  AuthedOwnerSiteSubjectsRoute: typeof AuthedOwnerSiteSubjectsRoute
  AuthedOwnerSiteTestimonialsRoute: typeof AuthedOwnerSiteTestimonialsRoute
  AuthedOwnerSiteIndexRoute: typeof AuthedOwnerSiteIndexRoute
}

const AuthedOwnerSiteRouteChildren: AuthedOwnerSiteRouteChildren = {
  AuthedOwnerSiteContentRoute: AuthedOwnerSiteContentRoute,
  AuthedOwnerSiteCoursesRoute: AuthedOwnerSiteCoursesRoute,
  AuthedOwnerSiteDirectionsRoute: AuthedOwnerSiteDirectionsRoute,
  AuthedOwnerSiteResultsRoute: AuthedOwnerSiteResultsRoute,
  AuthedOwnerSiteSubjectsRoute: AuthedOwnerSiteSubjectsRoute,
  AuthedOwnerSiteTestimonialsRoute: AuthedOwnerSiteTestimonialsRoute,
  AuthedOwnerSiteIndexRoute: AuthedOwnerSiteIndexRoute,
}

const AuthedOwnerSiteRouteWithChildren = AuthedOwnerSiteRoute._addFileChildren(
  AuthedOwnerSiteRouteChildren,
)

interface AuthedOwnerRouteChildren {
  AuthedOwnerAdminsRoute: typeof AuthedOwnerAdminsRoute
  AuthedOwnerCrmReasonsRoute: typeof AuthedOwnerCrmReasonsRoute
  AuthedOwnerLogsRoute: typeof AuthedOwnerLogsRoute
  AuthedOwnerPaymentAccountsRoute: typeof AuthedOwnerPaymentAccountsRoute
  AuthedOwnerPayrollRoute: typeof AuthedOwnerPayrollRoute
  AuthedOwnerSiteRoute: typeof AuthedOwnerSiteRouteWithChildren
  AuthedOwnerIndexRoute: typeof AuthedOwnerIndexRoute
}

const AuthedOwnerRouteChildren: AuthedOwnerRouteChildren = {
  AuthedOwnerAdminsRoute: AuthedOwnerAdminsRoute,
  AuthedOwnerCrmReasonsRoute: AuthedOwnerCrmReasonsRoute,
  AuthedOwnerLogsRoute: AuthedOwnerLogsRoute,
  AuthedOwnerPaymentAccountsRoute: AuthedOwnerPaymentAccountsRoute,
  AuthedOwnerPayrollRoute: AuthedOwnerPayrollRoute,
  AuthedOwnerSiteRoute: AuthedOwnerSiteRouteWithChildren,
  AuthedOwnerIndexRoute: AuthedOwnerIndexRoute,
}

const AuthedOwnerRouteWithChildren = AuthedOwnerRoute._addFileChildren(
  AuthedOwnerRouteChildren,
)

interface AuthedParentRouteChildren {
  AuthedParentAttendanceRoute: typeof AuthedParentAttendanceRoute
  AuthedParentBalancesRoute: typeof AuthedParentBalancesRoute
  AuthedParentBehaviorRoute: typeof AuthedParentBehaviorRoute
  AuthedParentHistoryRoute: typeof AuthedParentHistoryRoute
  AuthedParentNotificationsRoute: typeof AuthedParentNotificationsRoute
  AuthedParentPerformanceRoute: typeof AuthedParentPerformanceRoute
  AuthedParentScheduleRoute: typeof AuthedParentScheduleRoute
  AuthedParentIndexRoute: typeof AuthedParentIndexRoute
}

const AuthedParentRouteChildren: AuthedParentRouteChildren = {
  AuthedParentAttendanceRoute: AuthedParentAttendanceRoute,
  AuthedParentBalancesRoute: AuthedParentBalancesRoute,
  AuthedParentBehaviorRoute: AuthedParentBehaviorRoute,
  AuthedParentHistoryRoute: AuthedParentHistoryRoute,
  AuthedParentNotificationsRoute: AuthedParentNotificationsRoute,
  AuthedParentPerformanceRoute: AuthedParentPerformanceRoute,
  AuthedParentScheduleRoute: AuthedParentScheduleRoute,
  AuthedParentIndexRoute: AuthedParentIndexRoute,
}

const AuthedParentRouteWithChildren = AuthedParentRoute._addFileChildren(
  AuthedParentRouteChildren,
)

interface AuthedTeacherRouteChildren {
  AuthedTeacherAssessmentsRoute: typeof AuthedTeacherAssessmentsRoute
  AuthedTeacherAttendanceRoute: typeof AuthedTeacherAttendanceRoute
  AuthedTeacherGradesRoute: typeof AuthedTeacherGradesRoute
  AuthedTeacherGroupsRoute: typeof AuthedTeacherGroupsRoute
  AuthedTeacherHomeworkRoute: typeof AuthedTeacherHomeworkRoute
  AuthedTeacherLessonRoute: typeof AuthedTeacherLessonRoute
  AuthedTeacherMaterialsRoute: typeof AuthedTeacherMaterialsRoute
  AuthedTeacherMockExamsRoute: typeof AuthedTeacherMockExamsRoute
  AuthedTeacherPayrollRoute: typeof AuthedTeacherPayrollRoute
  AuthedTeacherScheduleRoute: typeof AuthedTeacherScheduleRoute
  AuthedTeacherIndexRoute: typeof AuthedTeacherIndexRoute
}

const AuthedTeacherRouteChildren: AuthedTeacherRouteChildren = {
  AuthedTeacherAssessmentsRoute: AuthedTeacherAssessmentsRoute,
  AuthedTeacherAttendanceRoute: AuthedTeacherAttendanceRoute,
  AuthedTeacherGradesRoute: AuthedTeacherGradesRoute,
  AuthedTeacherGroupsRoute: AuthedTeacherGroupsRoute,
  AuthedTeacherHomeworkRoute: AuthedTeacherHomeworkRoute,
  AuthedTeacherLessonRoute: AuthedTeacherLessonRoute,
  AuthedTeacherMaterialsRoute: AuthedTeacherMaterialsRoute,
  AuthedTeacherMockExamsRoute: AuthedTeacherMockExamsRoute,
  AuthedTeacherPayrollRoute: AuthedTeacherPayrollRoute,
  AuthedTeacherScheduleRoute: AuthedTeacherScheduleRoute,
  AuthedTeacherIndexRoute: AuthedTeacherIndexRoute,
}

const AuthedTeacherRouteWithChildren = AuthedTeacherRoute._addFileChildren(
  AuthedTeacherRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedAssessmentsRoute: typeof AuthedAssessmentsRoute
  AuthedCalculatorRoute: typeof AuthedCalculatorRoute
  AuthedForbiddenRoute: typeof AuthedForbiddenRoute
  AuthedGradesRoute: typeof AuthedGradesRoute
  AuthedHomeworkRoute: typeof AuthedHomeworkRoute
  AuthedLeadsRoute: typeof AuthedLeadsRoute
  AuthedMaterialsRoute: typeof AuthedMaterialsRoute
  AuthedMyMockExamsRoute: typeof AuthedMyMockExamsRoute
  AuthedOwnerRoute: typeof AuthedOwnerRouteWithChildren
  AuthedParentRoute: typeof AuthedParentRouteWithChildren
  AuthedScheduleRoute: typeof AuthedScheduleRoute
  AuthedTeacherRoute: typeof AuthedTeacherRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedLearningWorkIdRoute: typeof AuthedLearningWorkIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedAssessmentsRoute: AuthedAssessmentsRoute,
  AuthedCalculatorRoute: AuthedCalculatorRoute,
  AuthedForbiddenRoute: AuthedForbiddenRoute,
  AuthedGradesRoute: AuthedGradesRoute,
  AuthedHomeworkRoute: AuthedHomeworkRoute,
  AuthedLeadsRoute: AuthedLeadsRoute,
  AuthedMaterialsRoute: AuthedMaterialsRoute,
  AuthedMyMockExamsRoute: AuthedMyMockExamsRoute,
  AuthedOwnerRoute: AuthedOwnerRouteWithChildren,
  AuthedParentRoute: AuthedParentRouteWithChildren,
  AuthedScheduleRoute: AuthedScheduleRoute,
  AuthedTeacherRoute: AuthedTeacherRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedLearningWorkIdRoute: AuthedLearningWorkIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface ExamPortalRouteChildren {
  ExamPortalIndexRoute: typeof ExamPortalIndexRoute
  ExamPortalRegistrationIdTakeRoute: typeof ExamPortalRegistrationIdTakeRoute
}

const ExamPortalRouteChildren: ExamPortalRouteChildren = {
  ExamPortalIndexRoute: ExamPortalIndexRoute,
  ExamPortalRegistrationIdTakeRoute: ExamPortalRegistrationIdTakeRoute,
}

const ExamPortalRouteWithChildren = ExamPortalRoute._addFileChildren(
  ExamPortalRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  ExamAccessRoute: ExamAccessRoute,
  ExamPortalRoute: ExamPortalRouteWithChildren,
  ExamStatusRoute: ExamStatusRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
